module.exports = __webpack_public_path__ + "img/banner_02.55056637.png";